import sha256 from 'crypto-js/sha256';
export var sha256Func = function sha256Func(str) {
  return sha256(str).toString();
};